export const isTouchDevice = () => 'ontouchstart' in document.documentElement;

export const isMac = typeof navigator !== 'undefined' && /Mac OS X/.test(navigator.userAgent);
